exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".close-btn[data-v-ee0d0142]{font-size:20px}.margin-left-2[data-v-ee0d0142]{margin-left:4px}.margin-left-2[data-v-ee0d0142]:first-child{margin-left:0}", ""]);

// exports
